/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { ICustoPatrimonios, IDespesasCusto, Ios } from '../../../shared/services/api/Financeiro/Relatorios';
pdfMake.vfs = pdfFonts.pdfMake.vfs;


async function RCustoPatrimonio(despesa: IDespesasCusto[],  os: Ios[], patrimonio: ICustoPatrimonios, periodo: string){

  const contapagar = despesa.map((lan) => {
    return [
      {text: moment(lan.dataemissao).format('DD/MM/YYYY'), alignment: 'center',  fontSize: 7},
      {text: lan.numerodoc, alignment: 'left',  fontSize: 7},
      {text: lan.parceiro+'\nPlano Conta: '+lan.descricao, alignment: 'left',  fontSize: 7},
      {text: lan.historico, alignment: 'left',  fontSize: 7},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(lan.valor), alignment: 'right', fontSize: 7},
    ]; 
  });  

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous'; 
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl =  process.env.REACT_APP_URL_IMGLOG || ''; 
  const imageData = await getBase64ImageFromUrl(imageUrl);
  const imageUrl1 = (patrimonio.fotos === null ? process.env.REACT_APP_URL_IMGLOG || '' : process.env.REACT_APP_URL_IMGPATRIMONIO+patrimonio.fotos.imgPath || ''); 
  const imageData1 = await getBase64ImageFromUrl(imageUrl1);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }


  const documentDefinition : any = {
    pageSize: 'A4',  
    pageMargins: [20, 10, 20, 10], 
    content: [
      {
        style: 'tableExample',
        table: {
          margin: [0, 0, 0, 0],  
          widths: [48, 800],  
          body: [
            [ 
              {
                image: imageData,
                width: 48,
                border: [false, false, false, false]
              },  
              {
                width: 800,
                border: [false, false, false, false],
                table: {
                  body: [
                    [ 
                      {text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16,  margin: [0, 5, 0, 0], bold: true, color: process.env.COR_RELATORIOS_TEXTO,  alignment: 'center', fillColor: process.env.COR_RELATORIOS, border: [false, false, false, false]},
                    ],
                    [ 
                      {text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true]},
                    ],
                    [ 
                      {text: 'Relatório de Custo de Património', margin: [5, 10, 0, 0], fontSize: 18, bold: true,  alignment: 'center',  border: [false, false, false, false]},
                    ],
                  ]
                }
              }
            ],
          ]   
        }
      },
      {
        table: {
          widths: [70, 470],  
          body: [
            [ 
              {
                image: imageData1,
                width: 70,
                border: [false, true, false, true]     
              },  
              {
                width: 470,  
                border: [false, true, false, true],  
                table: {
                  body: [
                    [ 
                      {text: 'Património: '+patrimonio.numero+' - '+patrimonio.descricao,
                        fontSize: 16,  margin: [0, 5, 0, 0], bold: true, alignment: 'center', border: [false, false, false, false]},
                    ],
                    [ 
                      {text: 'Ano: '+patrimonio.ano,
                        fontSize: 16,  margin: [0, 5, 0, 0], bold: true, alignment: 'left', border: [false, false, false, false]},
                    ],
                  ]
                }
              }  
            ],
          ]      
        }
      },
      { text: 'Período de: '+periodo,  alignment: 'left', fillColor: '#dddddd', fontSize: 8},     
      {
        margin: [0, 10, 0, 10],
        style: 'tableExample',
        table:{
          widths: [130, 130, 130],
          body: [
            [
              {text: 'Lançamentos', fillColor: '#dddddd', border: [false, false, true, true], alignment: 'right',  fontSize: 8},
              {text: 'Ordem de Serviços', fillColor: '#dddddd', border: [false, false, true, true], alignment: 'right', fontSize: 8},
              {text: 'Total', fillColor: '#dddddd',  border: [false, false, true, true], alignment: 'right', fontSize: 8},
   
            ],
            [
              {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(patrimonio.totallan), 
                alignment: 'right', bold: true,  border: [false, false, true, false], fillColor: '#dddddd', fontSize: 18},
              {text: new Intl.NumberFormat('pt-br',  {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(patrimonio.totalos), 
                alignment: 'right', bold: true,  border: [false, false, true, false], fillColor: '#dddddd', fontSize: 18},
              {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(patrimonio.totallan + patrimonio.totalos), 
                alignment: 'right', bold: true,  border: [false, false, true, false], fillColor: '#dddddd',  fontSize: 18},
            ],
          ]
          
        },
        layout: {
          vLineWidth: function () {      
            return  10;   
          },
          vLineColor: function () {
            return '#ffffff';
          },
          hLineColor: function () {
            return '#ffffff';
          },
        }
      },  
      { text: 'Lançamentos', bold: true,  alignment: 'left', fillColor: '#dddddd', fontSize: 12}, 
      {
        table:{
          widths: [45, 50, 170, 200, 45],
          body: [
            [
              {text: 'Emissão', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'Documento', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'Parceiro / Plano Conta', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'Histórico', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'Valor', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
            ],
            ...contapagar,
          ]
             
        }, 
      },
      { text: (os.length > 0 ? 'Ordem de Serviços:' : 'Não há ordens de serviço registradas para este período.'), margin: [0, 5, 0, 0], bold: true,  
        alignment: 'left', fillColor: '#dddddd', fontSize: 12},    
      os.map(e => {
        const { itens } = e;
        const rows = itens.map((rowos) => {
          return [
            {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(rowos.qtdsaida), alignment: 'right',  fontSize: 8},
            {text: rowos.descricao, alignment: 'left',  fontSize: 7},
            {text: rowos.un, alignment: 'center',  fontSize: 7},
            {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(rowos.preco), alignment: 'right',  fontSize: 8},
            {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(rowos.total), alignment: 'right',  fontSize: 8},
          ]; 
        });  
        return [
          [             
            [ 
              {   
                margin: [0, 5, 0, 0],    
                table: { 
                  widths: [45, 45, 45, 120, 200, 45],
                  body: [
                    [
                      {text: 'Numero', fontSize: 7, alignment: 'left' },
                      {text: 'Abertura', fontSize: 7, alignment: 'left' },
                      {text: 'Fechamento', fontSize: 7, alignment: 'left' },
                      {text: 'Mecanico', fontSize: 7, alignment: 'left' },
                      {text: 'Serviço Realizado', fontSize: 7, alignment: 'left' },
                      {text: 'Valor', fontSize: 7, alignment: 'left' },
                    ],
                    [
                      {text: e.numero, fontSize: 7, alignment: 'left' },
                      {text: moment(e.dataabertura).format('DD/MM/YYYY'), alignment: 'center',  fontSize: 7},
                      {text: moment(e.datafechamento).format('DD/MM/YYYY'), alignment: 'center',  fontSize: 7},
                      {text: e.mecanico, fontSize: 7, alignment: 'left' },
                      {text: e.servicosrealizados, fontSize: 7, alignment: 'left' },
                      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(e.total), alignment: 'right',  fontSize: 7},
                    ],
                  ] 
                },     
              },                           
              {   
                table:{
                  widths: [45, 359, 15, 45, 45],
                  body: [
                    [
                      {text: 'Quantidade', border: [true, false, true, true], alignment: 'right', fillColor: '#dddddd', fontSize: 7},
                      {text: 'Descrição', border: [true, false, true, true],   alignment: 'center', fillColor: '#dddddd', fontSize: 7},
                      {text: 'UN', border: [true, false, true, true],  alignment: 'center', fillColor: '#dddddd', fontSize: 7},
                      {text: 'Valor Unt.', border: [true, false, true, true],  alignment: 'right', fillColor: '#dddddd', fontSize: 7},
                      {text: 'Total', border: [true, false, true, true], alignment: 'right', fillColor: '#dddddd', fontSize: 7},
                    ],
                    ...rows,
                  ]
                },       
              },                          
            ]
          ]                             
            
        ];
      }     
      ),
    ]
  };
  pdfMake.createPdf(documentDefinition).open();
}
export default RCustoPatrimonio; 


